import { FetchContext } from 'context/FetchContext';
import { useContext } from 'react';
import { useMutation, useQueryClient } from 'react-query';

function useManageSubjectPlans({ classID }) {
  const fetchContext = useContext(FetchContext);
  const { privateFetch } = fetchContext;
  const queryClient = useQueryClient();

  function updateES(data = {}) {
    return privateFetch.put(`/v1/admin/class/${classID}/plan`, data);
  }

  function manage(data) {
    return updateES(data);
  }

  return useMutation(manage, {
    async onMutate(variables) {
      await queryClient.cancelQueries(['class-subject-plans', classID]);

      const existingData = queryClient.getQueryData(['class-subject-plans', classID]);

      queryClient.setQueryData(['class-subject-plans', classID], (previous) => {
        if (previous?.data?._id === classID) {
          return {
            ...previous,
            data: {
              ...(previous?.data ?? {}),
              subjects: variables?.subjects ?? previous?.data?.subjects ?? [],
            },
          };
        }

        return previous;
      });

      return { existingData };
    },
    onSuccess() {},
    onError(error, newItem, context) {
      queryClient.setQueryData(['class-subject-plans', classID], context.existingData);
    },
    onSettled() {
      queryClient.invalidateQueries(['class-subject-plans', classID]);
    },
  });
}

export default useManageSubjectPlans;
